import Graphic from "@arcgis/core/Graphic";
import { pictureSymbolFunction } from "../../../services/genericMethoud/gisMethouds";

/**
 * Generates logos on the map
 */
export const generateLogos = (
  type: any,
  id: any,
  file: any,
  longitude: any,
  latitude: any,
  width: any,
  height: any,
  graphicsLogoLayer: any,
  graphicsLogoLayerlogoAdd: any,
  MapViewData?: any
) => {
  let picIcon: any = pictureSymbolFunction(file, width, height);
  let point: any = {
    type: "point",
    longitude: longitude,
    latitude: latitude,
    spatialReference: MapViewData?.spatialReference || { wkid: 4326 },
    id: id,
  };

  let attData = {
    logoId: id,
  };
  
  let pointGraphic = new Graphic({
    geometry: point,
    symbol: picIcon,
    attributes: attData,
  });
  
  if (type == "logoAdd") {
    graphicsLogoLayerlogoAdd.graphics.push(pointGraphic);
  } else {
    graphicsLogoLayer.graphics.push(pointGraphic);
  }
};

/**
 * Generates buildings wallet logos
 */
export const generateBuildingsWalletLogos = (
  id: any,
  longitude: any,
  latitude: any,
  parcel_Cod: any,
  land_Numbe: any,
  title: any,
  graphicsbuildingsWalletLayer: any
) => {

  let point: any = {
    type: "point",
    longitude: Number(longitude),
    latitude: Number(latitude),
    spatialReference: 102100,
    id: id,
  };
  let attData = {
    buildingsWalletId: id,
    parcel_Cod: parcel_Cod,
    land_Numbe: land_Numbe,
    title: title,
  };

  let symbolBuildingsWallet: any = {
    type: "simple-marker",
    style: "square",
    size: "15px",
    color: "#0031C4",
    outline: {
      color: "#77A4D2",
      width: "10px",
    },
  };
  
  // console.log("generateBuildingsWalletLogos point", point);

  let pointGraphic = new Graphic({
    geometry: point,
    symbol: symbolBuildingsWallet,
    attributes: attData,
  });
  
  graphicsbuildingsWalletLayer.graphics.push(pointGraphic);
};

/**
 * Removes logos by ID
 */
export const removeLogos = (id: any, getLogosData: any[], setGetLogosData: any) => {
  let newlogos = getLogosData.filter((getId: any) => getId.id !== id);
  setGetLogosData(newlogos);
};

/**
 * Removes logo graphics from layers
 */
export const removeLogoGraphics = (logoId: string, graphicsLogoLayer: any, graphicsLogoLayerlogoAdd: any) => {
  let currentGraphic = graphicsLogoLayer.graphics
    .filter((x: any) => x.attributes.logoId == logoId)
    .getItemAt(0);
    
  if (currentGraphic) {
    graphicsLogoLayer.graphics.remove(currentGraphic);
  } else {
    let currentGraphic = graphicsLogoLayerlogoAdd.graphics
      .filter((x: any) => x.attributes.logoId == logoId)
      .getItemAt(0);
    graphicsLogoLayerlogoAdd.graphics.remove(currentGraphic);
  }
};

/**
 * Sets logo layer visibility based on zoom level
 */
export const setLogoLayerVisibility = (zoom: number, graphicsLogoLayer: any, graphicsLogoLayerlogoAdd: any) => {
  if (zoom >= 18) {
    graphicsLogoLayer.visible = true;
  } else if (zoom <= 18) {
    graphicsLogoLayer.visible = false;
  }
  
  if (zoom >= 16) {
    graphicsLogoLayerlogoAdd.visible = true;
  } else if (zoom <= 16) {
    graphicsLogoLayerlogoAdd.visible = false;
  }
};
